// composables/useSignalR.ts
import { ref, onMounted, onUnmounted } from 'vue';
import * as signalR from '@microsoft/signalr';
import { publishToast, ToastSeverity } from '@/common/toastManager';

export interface UserHubNotification {
    uuid: string;
    title: string | null;
    text: string;
    createdUTc: string;
    actionLink?: string;
}

export function useSignalR() {

    const hubUrl = '/hubs/notifications';

    const connection = ref<signalR.HubConnection | null>(null);

    const isConnected = ref(false);

    const error = ref<string | null>(null);

    const startConnection = async () => {

        try {
            connection.value = new signalR.HubConnectionBuilder()
                .withUrl(hubUrl, {})
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Error)
                .build();

            // Подписка на события хаба. TODO: вынести наружу
            connection.value.on('receiveNotification', (notification: UserHubNotification) => {
                console.log('Получено уведомление:', notification);

                // задиспатчить бы
                publishToast({
                    title: notification.title || '',
                    body: notification.text,
                    actionLink: notification.actionLink,
                    severity: ToastSeverity.info,
                });
            });

            await connection.value.start();
            isConnected.value = true;
            error.value = null;
            console.log('SignalR подключен');
        } catch (err) {
            error.value = String(err);
            console.error('Ошибка подключения SignalR:', err);
        }
    }

    const stopConnection = async () => {
        if (connection.value) {
            try {
                await connection.value.stop();
                isConnected.value = false;
                console.log('SignalR отключен');
            } catch (err) {
                console.error('Ошибка отключения:', err);
            }
        }
    }

    onMounted(() => {
        startConnection();
    })

    onUnmounted(() => {
        stopConnection();
    })

    return {
        connection,
        isConnected,
        error
    }
}